import styled from "styled-components";

export const List = styled("ul")`
  margin: 0px;
  padding: 0px;

  &.list {
    padding: 0px;
    margin: 10px 0px;
    width: 100%;
  }

  &.multiLine {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  &:before {
    content: "";
    height: 1px;
    background-color: #707070;
    margin-top: 5px;
    margin-bottom: 15px;
  }
`;

export const Item = styled("li")`
  &.multiLine {
    list-style: none;
    display: flex;
    gap: 5px;
    padding: 3.5px 10.1px 4.5px 13px;
    align-items: center;
    border-radius: 11px;
    background-color: #d5f5ff;
    width: max-content;
    font-size: 12px;
    span {
      display: flex;
    }

    margin: 5px;
  }
  &.active {
    box-shadow: 0 0 4px 0 rgba(21, 115, 229, 0.3);
  }
  &.list {
    width: 100%;
    cursor: pointer;

    list-style: none;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: #334253;
    margin-bottom: 12px;

    span {
      display: flex;
    }
  }
  &.multiLine {
    list-style: none;
    display: flex;
    gap: 5px;
    padding: 1px 8px;
    align-items: center;
    border-radius: 11px;
    background-color: #d5f5ff;
    width: max-content;
    font-size: 12px;
  }
  &.list {
    width: 100%;
    list-style: none;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: #334253;
    margin-bottom: 12px;

    span {
      display: flex;
    }
  }
`;

export const Label = styled("label")`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 15px;
  padding: 0px 20px 7px;
  display: block;
  width: 100%;
  position: relative;

  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    background-color: #707070;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 35px;
  background-color: #fff;
  color: gray;
  padding-left: 5px;
  font-size: 14px;
  border: none;
  margin-left: 10px;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  outline: none;
  border-radius: 5px;
  user-select: none;
  option {
    color: black;
    background: white;
    display: flex;
    background-color: #f5f5f5;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;
